



































import Component from "vue-class-component";
import Vue from 'vue';
import EventApi from "../api/EventsApi";

@Component({
    props: {
        videoId: {
            required: true,
            type: String,
        },
    },
})

export default class VideoEmbed extends Vue {
    private modalIsVisible: boolean = false;
    private videoButtonStubUrl: string = '/images/stubs/start-page-video-stub.jpg';
    private videoStubInModalUrl: string = '/images/stubs/video-stub.jpg';

    /**
     * Домен
     * @private
     */
    private get location(): string
    {
        return location.origin;
    }

    /**
     * Показать модалку
     * @private
     */
    private showModal(): void
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.modalIsVisible = true;
    }

    /**
     * Скрыть модалку
     * @private
     */
    private hideModal(): void
    {
        this.modalIsVisible = false;
    }
}
